import { render, staticRenderFns } from "./CoachesEscuelasAlumnos.vue?vue&type=template&id=6d57e1b0&scoped=true&"
import script from "./CoachesEscuelasAlumnos.vue?vue&type=script&lang=js&"
export * from "./CoachesEscuelasAlumnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d57e1b0",
  null
  
)

export default component.exports